import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function DirectoryPagination({ page, pageSize, total, onChange }) {
  const { t } = useTranslation('directories');
  if (total <= pageSize) return null;
  return <nav className="dr-pagination" aria-label={t('pagination')}>
    <span>{t('pageRange', { from: (page - 1) * pageSize + 1, to: Math.min(page * pageSize, total), count: total })}</span>
    <div>
      <Button disabled={page === 1} onClick={() => onChange(page - 1)}>{t('previous')}</Button>
      <Button disabled={page * pageSize >= total} onClick={() => onChange(page + 1)}>{t('next')}</Button>
    </div>
  </nav>;
}
